// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  position: relative;
}

.sub-titlebar {
  font-size: 14px;
  padding: 8px;
  align-items: center;
  gap: 10px;
  display: flex;
  margin-top: -10px;
  width: calc(100% - 100px);
  z-index: 10000;
}
.sub-titlebar input {
  z-index: 5;
}

#modelSelect {
  max-width: 300px !important;
}

.fixed-width-100 {
  width: 100px;
}

.chartContainer {
  height: 100%;
}

.smol {
  width: 150px;
  height: 24px;
  line-height: 22px;
  font-size: 12px;
}

.network {
  position: absolute;
  top: 10px;
  right: 80px;
  color: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  font-size: 12px;
}

#searchInput, #searchInput:focus-visible {
  border: none;
  font-size: 10px;
  width: calc(100% - 10px);
  outline: none;
  padding: 5px;
}

.virtual-scroll {
  height: 20vh;
  width: 300px;
  overflow-x: hidden;
  overflow-y: scroll !important;
  scrollbar-color: black white;
  scrollbar-width: thin;
}

.item {
  box-sizing: border-box;
  height: 50px;
  width: 100%;
  display: flex;
}

::ng-deep .mat-mdc-select-panel {
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

::ng-deep div.mat-mdc-select-panel {
  max-height: 475px;
  overflow-y: auto !important;
}

.loading {
  color: rgba(255, 255, 255, 0.8);
}

.right {
  position: absolute;
  right: 0;
}

app-spinner {
  z-index: 100;
  position: absolute;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  width: 100px;
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/model-chart-widget/model-chart-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,eAAA;EAEA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAAF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,eAAA;AAJF;;AAOA;EACE,YAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,qBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAJF;;AAOA;EACE,6BAAA;EACA,6BAAA;AAJF;;AAQA;EACE,iBAAA;EACA,2BAAA;AALF;;AAUA;EACE,+BAAA;AAPF;;AAUA;EACE,kBAAA;EACA,QAAA;AAPF;;AAUA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAPF","sourcesContent":[".content {\n  position:relative;\n}\n\n.sub-titlebar {\n  font-size: 14px;\n\n  padding: 8px;\n  align-items: center;\n  gap: 10px;\n  display: flex;\n  margin-top: -10px;\n  width: calc(100% - 100px);\n  z-index: 10000;\n  & input {\n    z-index: 5;\n  }\n}\n\n#modelSelect {\n  max-width: 300px !important;\n}\n\n.fixed-width-100 {\n  width: 100px;\n}\n\n// ::ng-deep .mat-select-panel {\n//   max-width: unset!important;\n// }\n\n.chartContainer {\n  height: 100%;\n}\n\n.smol {\n  width: 150px;\n  height: 24px;\n  line-height: 22px;\n  font-size: 12px;\n}\n\n.network {\n  position: absolute;\n  top: 10px;\n  right: 80px;\n  color: rgba(255, 255, 255, 0.5);\n  z-index: 1000;\n  font-size: 12px;\n}\n\n#searchInput, #searchInput:focus-visible {\n  border: none;\n  font-size: 10px;\n  width: calc(100% - 10px);\n  outline: none;\n  padding: 5px;\n}\n\n.virtual-scroll {\n  height: 20vh;\n  width: 300px;\n  overflow-x: hidden;\n  overflow-y:scroll !important;\n  scrollbar-color: black white;\n  scrollbar-width: thin;\n}\n\n.item {\n  box-sizing: border-box;\n  height: 50px;\n  width: 100%;\n  display: flex;\n}\n\n::ng-deep .mat-mdc-select-panel {\n  overflow-x: hidden !important;\n  overflow-y: hidden !important;\n\n}\n\n::ng-deep div.mat-mdc-select-panel {\n  max-height: 475px;\n  overflow-y: auto !important;\n  // height: 50vh;\n\n}\n\n.loading {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.right {\n  position: absolute;\n  right: 0;\n}\n\napp-spinner {\n  z-index: 100;\n  position: absolute;\n  top: calc(50% - 50px);\n  left: calc(50% - 50px);\n  width: 100px;\n  height: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
